module.exports = __webpack_public_path__ + "media/images/main_nav_version_num-95617d4bfbb25ad59b575817c767ea3c.png";